<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <!--    <b-form-group-->
    <!--      label="Slug"-->
    <!--      label-for="slug"-->
    <!--    >-->
    <!--      <b-form-input-->
    <!--        id="slug"-->
    <!--        v-model="itemData.translate.slug"-->
    <!--        placeholder="Slug"-->
    <!--      />-->
    <!--      <b-alert show>-->
    <!--        <div class="alert-body mt-1 font-small-2">-->
    <!--          {{ itemData.item.slug }}-->
    <!--        </div>-->
    <!--      </b-alert>-->
    <!--    </b-form-group>-->
    <b-form-group
      label="metatag_title"
      label-for="metatag_title"
    >
      <b-form-input
        id="metatag_title"
        v-model="itemData.translate.metatag_title"
        placeholder="metatag_title"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.metatag_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="metatag_description"
      label-for="metatag_description"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.metatag_description"
        placeholder="metatag_description"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.metatag_description }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Üst Metin"
      label-for="subtitle"
    >
      <quill-editor
        id="summary"
        v-model="itemData.translate.summary"
        class="bg-white"
        :options="editorOptionSummary"
      >
        <div
          id="summary_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.summary" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin"
      label-for="subtitle"
    >
      <quill-editor
        id="content"
        v-model="itemData.translate.content"
        class="bg-white"
        :options="editorOptionContent"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.content" />
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'ServiceCategories',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
    quillEditor,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOptionSummary: {
        modules: {
          toolbar: '#summary_toolbar', // Use summary toolbar
        },
        theme: 'snow',
      },
      editorOptionContent: {
        modules: {
          toolbar: '#content_toolbar', // Use content toolbar
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
